import type { SortingChapter } from "../sorting/chapters.ts";

/** The ten Lối Ngọc chapters (10 levels each); same shape as the other houses. */
export type TileChapter = SortingChapter;

const chapter = (n: number, themeId: string, name: string, focus: string, palette: readonly [string, string]): TileChapter => ({
  chapter: n,
  themeId,
  name,
  focus,
  firstLevel: (n - 1) * 10 + 1,
  lastLevel: n * 10,
  palette,
});

/** Every chapter adds exactly one idea (docs/TILE_CASTLE.md §3). */
export const TILE_CHAPTERS: readonly TileChapter[] = [
  chapter(1, "castle-gate", "Cổng Lâu Đài", "Bước đi, nhặt gạch, ghép ba", ["#e6f6ee", "#fff4e0"]),
  chapter(2, "paved-hall", "Đá Lát", "Đá lát đi lại bao nhiêu lần cũng được", ["#f2efe2", "#e3f3ec"]),
  chapter(3, "stacked-tiles", "Gạch Chồng", "Ô hai lớp, ghé hai lần", ["#e2f4f0", "#f0e9ff"]),
  chapter(4, "small-satchel", "Túi Nhỏ", "Túi chỉ còn ít ngăn", ["#fff0e3", "#e7f5ea"]),
  chapter(5, "jade-locks", "Cửa Khóa Ngọc", "Cửa mở khi ghép xong một hình", ["#fff6da", "#e4f4ec"]),
  chapter(6, "mirrors", "Gương Thần", "Bước vào gương này, ra gương kia", ["#e7ecff", "#e6f7f1"]),
  chapter(7, "face-down", "Gạch Úp", "Gạch úp lộ hình khi đứng sát bên", ["#ece7f6", "#e2f2ec"]),
  chapter(8, "locks-face-down", "Khóa và Gạch Úp", "Cửa khóa gặp gạch úp", ["#f6eedc", "#e6e8f6"]),
  chapter(9, "mirror-stacks", "Gương và Gạch Chồng", "Gương thần gặp gạch chồng", ["#e3effd", "#f3ebff"]),
  chapter(10, "masterpiece", "Kiệt Tác", "Mọi bí kíp, về đích trên ngai vàng", ["#fff3e6", "#e4f6ee"]),
];

export function tileChapterOfLevel(levelId: number): TileChapter {
  const found = TILE_CHAPTERS[Math.floor((levelId - 1) / 10)];
  if (!found) throw new RangeError(`no chapter for level ${levelId}`);
  return found;
}
